import React from 'react'
import styled from 'styled-components'

import { Box, Text } from '@usap/uicomponents'

export const ProductNameBox = styled(Box)`
  width: 100%;

${props => props.theme.mediaQuery.up('tablet-landscape')} {
  width: 500px;
}
`

export const PartNoBox = styled(Box)`
  margin-top: 16px;
`

export const ItemTotalBox = styled(Box)`
  margin-top: 12px;
  padding-top: 4px;
  padding-bottom: 4px;
  flex-direction: row;
  align-items: center;
`

export const ItemTotalValue = styled(Text)`
  margin-left: 2px;
`

export const ShippingMethodValue = styled(Text)`
  margin-left: 0;
`
